/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { HttpHeaders } from '@angular/common/http';

export abstract class ApiClient {
  readonly LD_JSON_HEADERS = new HttpHeaders()
    .set('Accept', 'application/ld+json')
    .set('Content-Type', 'application/ld+json');

  extractId(url: string): string {
    return url.replace( /^\D+/g, '');
  }
}
